import React from "react";
import { AlertTriangleIcon } from "lucide-react";
import { quoteSpec, quoteRows, quoteNotes } from "../data/factoryQuote";
const money = (n: number) => n.toLocaleString("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: n % 1 ? 2 : 0
});
export function FactoryQuote() {
  return <section aria-labelledby="quote-h" className="grid gap-10 lg:grid-cols-[1fr_1.5fr]" data-id="element-37" data-mp="1qr9g85kmf3zd">
      <div data-id="element-38" data-mp="25fw6317vje4u">
        <h2 id="quote-h" className="text-xl font-semibold text-ink" data-id="element-39" data-mp="25fmdr6zcwuvz">Your factory quote</h2>
        <dl className="mt-4 divide-y divide-line border-y border-line text-sm" data-id="element-40" data-mp="20i44ffhfgdng">
          {quoteSpec.map(s => <div key={s.label} className="flex justify-between gap-4 py-3" data-id="element-41" data-mp="2eg1089o24g12">
              <dt className="text-muted" data-id="element-42" data-mp="29hhiymkersf1">{s.label}</dt>
              <dd className="text-right font-medium text-ink" data-id="element-43" data-mp="29fwkwmyvxrcf">{s.value}</dd>
            </div>)}
        </dl>
        <ul className="mt-6 flex flex-col gap-3" data-id="element-44" data-mp="f3zpkixbo1c3">
          {quoteNotes.map(n => <li key={n} className="flex gap-2 text-sm text-muted" data-id="element-45" data-mp="f6cgvmoyzo1t">
              <AlertTriangleIcon className="mt-0.5 h-4 w-4 shrink-0 text-amber" data-id="element-46" data-mp="zerjur13deca" />
              {n}
            </li>)}
        </ul>
      </div>

      <div className="overflow-x-auto" data-id="element-47" data-mp="19bw6st2rhdu5">
        <table className="w-full min-w-[520px] text-left text-sm" data-id="element-48" data-mp="19auj9p4k6yvj">
          <thead className="border-b border-ink text-muted" data-id="element-49" data-mp="1e2uonx3eejzi">
            <tr data-id="element-50" data-mp="1e4fjzoxje6yf">
              <th className="py-3 font-medium" data-id="element-51" data-mp="1i3y2ke1vy5y3">Qty</th>
              <th className="py-3 font-medium" data-id="element-52" data-mp="1i3el0yg5djkl">Shipping</th>
              <th className="py-3 text-right font-medium" data-id="element-53" data-mp="1n2hqgk01hrt3">Per unit</th>
              <th className="py-3 text-right font-medium" data-id="element-54" data-mp="1n4u80w1vy05m">Total</th>
            </tr>
          </thead>
          <tbody data-id="element-55" data-mp="1s09kbjk8vnzx">
            {quoteRows.map(row => row.rates.map((r, i) => {
            const recommended = row.qty === 3000 && r.method === "Sea";
            return <tr key={`${row.qty}-${r.method}`} className={`${i === row.rates.length - 1 ? "border-b border-line" : ""} ${recommended ? "bg-ink text-paper" : ""}`} data-id="element-56" data-mp="3tvtjjbp6eq1i" data-mpi={i}>
                    <td className="py-3 pl-2 align-top" data-id="element-57" data-mp="3qs4b9toe1v4n">
                      {i === 0 && <>
                          <span className="font-semibold" data-id="element-58" data-mp="3lv5ipfkdhw8k">{row.qty.toLocaleString()}</span>
                          <span className="block text-xs text-muted" data-id="element-59" data-mp="4ikzi5gzi7ny">{row.production} to make</span>
                        </>}
                    </td>
                    <td className="py-3" data-id="element-60" data-mp="djrfmdfq1ggo">
                      {r.method} <span className={recommended ? "text-paper/60" : "text-muted"} data-id="element-61" data-mp="8mizsji1poil">· {r.transit}</span>
                    </td>
                    <td className="py-3 text-right tabular-nums" data-id="element-62" data-mp="na41qa36phox">{money(r.unit)}</td>
                    <td className="py-3 pr-2 text-right font-semibold tabular-nums" data-id="element-63" data-mp="ibsqbux8qz4l">{money(r.total)}</td>
                  </tr>;
          }))}
          </tbody>
        </table>
        <p className="mt-3 text-sm text-muted" data-id="element-64" data-mp="sb9sw3h74wwc">
          <span className="font-semibold text-ink" data-id="element-65" data-mp="s8f8gby6nc2x">Best fit: 3,000 by sea.</span> It's the minimum for fully custom art and the cheapest way to launch a full series (1,000 of each character, if they allow the split).
        </p>
      </div>
    </section>;
}